module.exports = __webpack_public_path__ + "img/Car Icon - white.43bfe9b2.svg";